import { Injectable } from '@angular/core';
import { DrQueryParams, OpData } from '../base/base-service-with-bundle.service';
import { HttpServiceBundle } from '../base/http-service-bundle.service';
import { Observable } from 'rxjs';
import { CaseResult } from '../../../shared/models/case-result';
import {
    BaseHttpService, GetById,
    Patch,
    UriBuilderParams
} from '../base/base-http.service';
import { BackendUriUnits } from '../base/backend-uri-units';

export class ResultsUriBuilderParams extends UriBuilderParams<CaseResult> {

    constructor(result: CaseResult | string) {
        super(result);
    }

    public buildUri(): string {
        return `/${BackendUriUnits.CASES}/${this.base}/${BackendUriUnits.RESULT}`;
    }
}

@Injectable({
    providedIn: 'root'
})
export class ResultService extends BaseHttpService<CaseResult, ResultsUriBuilderParams>
                           implements GetById<CaseResult, ResultsUriBuilderParams>,
                                      Patch<CaseResult, ResultsUriBuilderParams> {

    constructor(httpServiceBundle: HttpServiceBundle) {
        super(CaseResult, httpServiceBundle);
    }

    public getById(uriParams: ResultsUriBuilderParams, params?: DrQueryParams, propOverride?: string): Observable<CaseResult> {
        return this.getBaseById(uriParams, params, propOverride);
    }

    public patch(uriParams: ResultsUriBuilderParams, data: OpData[], params?: DrQueryParams): Observable<CaseResult> {
        return this.patchBase(uriParams, data, params);
    }

    public patchAndUpdate(uriParams: ResultsUriBuilderParams, caseResult: CaseResult, data: OpData[], params?: DrQueryParams): Observable<CaseResult> {
        return this.patchAndUpdateBase(uriParams, caseResult, data, params, true);
    }

}
